import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocalStore } from '../../../store/store.decorator';
import { IStoreDataV3 } from '@df/catalog/store/store';

@Component({
    selector: 'page-store-finder-store-status',
    templateUrl: 'page-store-finder-store-status.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageStoreFinderStoreStatusComponent {
    /**
     * Store
     */
    @Input()
    store?: LocalStore<IStoreDataV3>;
}
